import CONFIG from '@webclient/lib/const/user-specific-settings';

import { RootType } from '@webclient/state/store';

import { createSelector } from '@reduxjs/toolkit';

const selectAuth = (state: RootType) => state.auth;
const selectAppSettings = (state: RootType) => state.appSettings;
const selectUserSpecificSettings = createSelector(
  selectAppSettings,
  (appSettings) => appSettings.userSpecificSettings,
);

const selectCurrentUserId = createSelector(selectAuth, (auth) => auth.me?.uuid);

export const selectCurrentUserSettings = createSelector(
  [selectUserSpecificSettings, selectCurrentUserId],
  (userSettings, userId) =>
    userId
      ? (userSettings?.[userId] ?? CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS)
      : CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS,
);

export const makeSelectUserSetting = <
  K extends keyof typeof CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS,
>(
  key: K,
) => createSelector(selectCurrentUserSettings, (settings) => settings[key]);

export const selectSearchScope = makeSelectUserSetting('searchScope');
export const selectVoice = makeSelectUserSetting('voice');
export const selectResponseLength = makeSelectUserSetting('responseLength');
export const selectBot = makeSelectUserSetting('bot');
export const selectCustomStyle = makeSelectUserSetting('customStyle');
export const selectUseCustomStyle = makeSelectUserSetting('useCustomStyle');
export const selectShouldSaveUploadsToKnowledgeBase = makeSelectUserSetting(
  'shouldSaveUploadsToKnowledgeBase',
);
export const selectSearchMode = makeSelectUserSetting('searchMode');
export const selectResearchAdvancedTime = makeSelectUserSetting(
  'researchAdvancedTime',
);
/**
 * Selector for advanced PDF ingestion setting.
 */
export const selectAdvancedPdfIngestion = makeSelectUserSetting(
  'advancedPdfIngestion',
);
